// Bilingual content (EN / HI) for Hari Ram Purwar franchise landing page.
export const content = {
  en: {
    nav: {
      heritage: "Heritage",
      odoc: "ODOC",
      menu: "Menu",
      model: "Franchise Model",
      financials: "Financials",
      premium: "Premium Plan",
      faq: "FAQ",
      apply: "Apply Now",
    },
    hero: {
      eyebrow: "Since 1890 · Meerapur, Prayagraj",
      h1_part1: "From the Historic Streets of",
      h1_highlight: "Prayagraj",
      h1_part2: "to a Nationwide Phenomenon",
      sub: "Partner with India's ultimate taste legacy. Join the Hari Ram Purwar franchise family and bring 135+ years of culinary heritage to your city.",
      cta_primary: "Partner With Us",
      cta_secondary: "View Financials",
      stat_years: "Years of Legacy",
      stat_years_value: "135+",
      stat_ghee: "Pure Desi Ghee",
      stat_odoc: "ODOC Certified",
      stat_categories: "Menu Categories",
    },
    heritage: {
      eyebrow: "Our Legacy",
      title: "135+ Years of Purity",
      p1: "Established in 1890 in Prayagraj, Hari Ram Purwar (originally Hari Ram & Sons) has been the gold standard of authentic Indian savories for generations. What started as a single humble shop has transitioned through decades — fiercely preserving secret family spice blends and traditional culinary artistry.",
      p2: "Legendary historical figures, freedom fighters, and local visionaries have all walked through our doors to relish our flavors. Today, customers ship our snacks to families across the USA, Europe, and the Middle East.",
      ghee_label: "The Pure Desi Ghee Promise",
      ghee_text: "Every single batch of our namkeens, samosas, and snacks is prepared in 100% Pure Desi Ghee. No shortcuts. No compromise. Just the same unforgettable taste, since 1890.",
      pill_1: "100% Desi Ghee",
      pill_2: "Secret Family Spices",
      pill_3: "Hand-Crafted Daily",
    },
    marquee: [
      "ODOC Winner — Taste of Uttar Pradesh",
      "135+ Years of Legacy",
      "100% Pure Desi Ghee",
      "Turnkey Franchise Model",
      "ROI in 2–3 Years",
      "Officially Government Recognised",
    ],
    odoc: {
      eyebrow: "The Ultimate Badge of Honor",
      title: "Officially Crowned The Taste of Uttar Pradesh",
      p1: "Prayagraj's beloved samosa has been officially selected under the Uttar Pradesh government's ambitious ODOC (One District One Cuisine) initiative. The ODOC certification is awarded strictly to native culinary treasures that represent the pinnacle of regional heritage, taste, and quality.",
      p2: "As a franchise partner, you inherit a brand that carries official state backing, unmatched credibility, and a pre-existing cult-like customer following across India.",
      badge_state: "State Recognition",
      badge_tourism: "Culinary Tourism Map",
      badge_credibility: "Unmatched Credibility",
    },
    menu: {
      eyebrow: "Multi-Category Menu",
      title: "The True Taste of Prayagraj",
      sub: "Four high-demand categories ensure constant footfall — from morning chai to late-night cravings.",
      cats: [
        {
          tag: "The Pride",
          title: "Iconic Samosas & Savories",
          desc: "Our ODOC-winning Mini Masala Samosa (Hari Ke Samose), crafted in 100% desi ghee, alongside crunchy, tangy, premium namkeens that customers buy in bulk.",
        },
        {
          tag: "The Soul",
          title: "Khasta Samose & Prayagraj Street Food",
          desc: "Our signature Khasta Samose with secret family spice mixes, classic crispy Kachoris and traditional tangy chaat platters — the fiery, soulful flavors Prayagraj is celebrated for.",
        },
        {
          tag: "The Crowd-Puller",
          title: "Trendy Fast Food Favorites",
          desc: "Crispy french fries, juicy burgers, loaded sandwiches and quick snacks — high-margin items built to attract youth, families, and quick-bite hangouts.",
        },
        {
          tag: "The Cash Counter",
          title: "Kulhad Chai & Beverages",
          desc: "A dedicated beverage counter — premium Kulhad Chai, traditional local drinks and refreshing cold beverages. India's most frequent daily purchase, your steady cash generator.",
        },
      ],
    },
    turnkey: {
      eyebrow: "Zero-Hassle Setup",
      title: "We Build, You Earn",
      sub: "A complete, turnkey business handed to you on a platter. Everything required to launch and operate — handled by our corporate team.",
      items: [
        { t: "Complete Kitchen Equipment", d: "Heavy-duty commercial appliances & specialised tooling, fully fitted to our menu." },
        { t: "The Full Iconic Menu", d: "Direct access to ODOC-winning samosas, street food, fast food and beverages." },
        { t: "Premium Raw Materials", d: "Continuous supply of authentic ingredients and our secret spice blends." },
        { t: "Professional Interior Design", d: "An eye-catching outlet reflecting our 135-year legacy with optimised space." },
        { t: "Staff Recruitment & Training", d: "We help you hire and train your team in our traditional methods and service." },
        { t: "End-to-End Launch Support", d: "From store layout to grand opening marketing — fully handled by our team." },
      ],
    },
    financials: {
      eyebrow: "The Numbers",
      title: "The Franchise Financial Blueprint",
      sub: "Designed for real, sustainable revenue — not paper promises.",
      cards: [
        { label: "Initial Setup Investment", value: "₹40–45L", note: "All-inclusive: design, equipment, stock, branding, launch." },
        { label: "Required Commercial Area", value: "150–400", unit: "sq. ft.", note: "Optimised for high-footfall markets, main roads, commercial hubs." },
        { label: "Expected Monthly Revenue", value: "₹10–20L", note: "Varies by location, footfall and local market dynamics." },
        { label: "Return on Investment", value: "2–3 yrs", note: "Healthy margins on Desi Ghee products & multi-category sales." },
      ],
      royalty: "10% Royalty",
      royalty_text: "Includes brand support, supply chain access, menu innovation & national marketing campaigns.",
    },
    premium: {
      tag: "Flagship Tier",
      eyebrow: "Our Premium Franchise Plan",
      title: "The Complete House of Hari Ram Purwar",
      sub: "A flagship outlet that carries the entire universe of our brand — every spice, every snack, every signature recipe. Built for serious partners aiming to dominate their city.",
      bullet_title: "Everything Under One Roof",
      bullets: [
        "Complete spice & masala retail range",
        "Full namkeen and sweets line",
        "All hot snacks, chaat & street food",
        "Modern fast food and beverages",
        "Premium Kulhad Chai counter",
        "Take-away, dine-in & gifting packs",
      ],
      stats: [
        { label: "Required Area", value: "500–1000", unit: "sq. ft." },
        { label: "Investment", value: "On Request" },
        { label: "Monthly Revenue", value: "₹10–20L+" },
        { label: "Tier", value: "Flagship" },
      ],
      cta: "Apply for Premium Plan",
    },
    form: {
      eyebrow: "Begin Your Journey",
      title: "Franchise Application",
      sub: "Tell us about you. Our partnership team will respond within 48 hours.",
      contact_title: "Talk to our partnership team",
      labels: {
        name: "Full Name",
        mobile: "Mobile Number",
        email: "Email Address",
        city: "Target City",
        state: "Target State",
        capacity: "Proposed Investment Capacity",
        plan: "Preferred Franchise Plan",
        profile: "Current Business / Experience (Optional)",
      },
      placeholders: {
        name: "e.g. Aarav Sharma",
        mobile: "10-digit mobile number",
        email: "your@email.com",
        city: "e.g. Lucknow",
        state: "e.g. Uttar Pradesh",
        profile: "Briefly describe your background, current business or relevant experience…",
      },
      capacity_options: [
        "₹35–40 Lakhs",
        "₹40–45 Lakhs",
        "₹45–50 Lakhs",
      ],
      plan_options: ["Standard (150–400 sq. ft.)", "Premium (500–1000 sq. ft.)"],
      submit: "Submit Application",
      submitting: "Submitting…",
      success_title: "Application received",
      success_body: "Thank you — our partnership team will reach out within 48 hours.",
      error_title: "Submission failed",
      error_body: "Please try again or call us directly.",
    },
    faq: {
      eyebrow: "Common Questions",
      title: "Frequently Asked",
      items: [
        {
          q: "How long does it take to launch a Hari Ram Purwar outlet?",
          a: "Typically 60 to 90 days from signing — covering location finalisation, interior fit-out, equipment installation, staff training and a soft launch.",
        },
        {
          q: "Do I need prior F&B experience to become a partner?",
          a: "No. Our turnkey model is designed for first-time entrepreneurs as well as seasoned operators. We provide complete training, SOPs and ongoing operational support.",
        },
        {
          q: "What does the 10% royalty fee actually cover?",
          a: "Continuous brand support, central supply chain access for raw materials & spice blends, ongoing menu innovation and national-level marketing campaigns.",
        },
        {
          q: "What's the difference between the Standard and Premium plans?",
          a: "Standard (150–400 sq. ft.) focuses on our iconic snacks, samosas and chai. Premium (500–1000 sq. ft.) is a flagship outlet stocking our entire product universe — spices, sweets, namkeens, street food, fast food and beverages.",
        },
        {
          q: "Can I open multiple outlets in my city or state?",
          a: "Yes. We welcome multi-unit and master franchise discussions in unserved markets across India. Mention your intent in the application form.",
        },
        {
          q: "Is taste consistency really guaranteed across outlets?",
          a: "Absolutely. Our central supply of secret spice blends and pure desi ghee — combined with structured staff training — ensures the same legendary taste in every city.",
        },
      ],
    },
    footer: {
      tagline: "India's Ultimate Taste Legacy. Since 1890.",
      call: "Call our partnership desk",
      address: "In front of Krishna Pranami Mandir, Meerapur, Prayagraj — 211003, Uttar Pradesh, India",
      rights: "All rights reserved.",
    },
  },

  hi: {
    nav: {
      heritage: "विरासत",
      odoc: "ODOC",
      menu: "मेन्यू",
      model: "फ्रेंचाइज़ी मॉडल",
      financials: "वित्तीय",
      premium: "प्रीमियम प्लान",
      faq: "सवाल-जवाब",
      apply: "आवेदन करें",
    },
    hero: {
      eyebrow: "1890 से · मीरापुर, प्रयागराज",
      h1_part1: "प्रयागराज की ऐतिहासिक गलियों से",
      h1_highlight: "देश भर तक",
      h1_part2: "एक स्वाद की लहर",
      sub: "भारत की सबसे प्रामाणिक स्वाद विरासत के साथ साझेदारी करें। 135+ साल पुरानी पाक परंपरा को अपने शहर तक पहुंचाएँ।",
      cta_primary: "हमारे साथ जुड़ें",
      cta_secondary: "वित्तीय देखें",
      stat_years: "वर्षों की विरासत",
      stat_years_value: "135+",
      stat_ghee: "शुद्ध देसी घी",
      stat_odoc: "ODOC प्रमाणित",
      stat_categories: "मेन्यू श्रेणियाँ",
    },
    heritage: {
      eyebrow: "हमारी विरासत",
      title: "135+ वर्षों की शुद्धता",
      p1: "1890 में प्रयागराज में स्थापित, हरि राम पुरवार (मूल रूप से हरि राम एंड संस) पीढ़ियों से प्रामाणिक भारतीय नमकीन का स्वर्ण मानक रहा है। एक छोटी सी दुकान से शुरू होकर, हमने आज तक अपने गुप्त मसाला मिश्रण और पाक कला को पूरी निष्ठा से संजोया है।",
      p2: "ऐतिहासिक व्यक्तित्व, स्वतंत्रता सेनानी और स्थानीय दूरदर्शी — सब हमारे दरवाज़े से स्वाद चखकर निकले हैं। आज ग्राहक हमारे स्नैक्स अमेरिका, यूरोप और मध्य पूर्व तक अपने परिवारों को भेजते हैं।",
      ghee_label: "शुद्ध देसी घी का वादा",
      ghee_text: "हमारे नमकीन, समोसे और स्नैक्स का हर बैच 100% शुद्ध देसी घी में बनता है। कोई शॉर्टकट नहीं। कोई समझौता नहीं। 1890 से वही अविस्मरणीय स्वाद।",
      pill_1: "100% देसी घी",
      pill_2: "गुप्त पारिवारिक मसाले",
      pill_3: "रोज़ हाथ से तैयार",
    },
    marquee: [
      "ODOC विजेता — उत्तर प्रदेश का स्वाद",
      "135+ वर्षों की विरासत",
      "100% शुद्ध देसी घी",
      "टर्नकी फ्रेंचाइज़ी मॉडल",
      "2–3 वर्षों में ROI",
      "आधिकारिक सरकारी मान्यता",
    ],
    odoc: {
      eyebrow: "सर्वोच्च सम्मान",
      title: "आधिकारिक रूप से उत्तर प्रदेश का स्वाद",
      p1: "प्रयागराज का प्रिय समोसा उत्तर प्रदेश सरकार की महत्वाकांक्षी ODOC (एक जिला एक व्यंजन) पहल के तहत आधिकारिक रूप से चुना गया है। ODOC प्रमाणन केवल उन व्यंजनों को मिलता है जो क्षेत्रीय विरासत, स्वाद और गुणवत्ता की शिखर हैं।",
      p2: "फ्रेंचाइज़ी साझेदार के रूप में आपको एक ऐसा ब्रांड मिलता है जिसके पास राज्य का आधिकारिक समर्थन, बेजोड़ विश्वसनीयता और पूरे भारत में मौजूद ग्राहकों का बड़ा परिवार है।",
      badge_state: "राज्य मान्यता",
      badge_tourism: "पाक पर्यटन मानचित्र",
      badge_credibility: "बेजोड़ विश्वसनीयता",
    },
    menu: {
      eyebrow: "बहु-श्रेणी मेन्यू",
      title: "प्रयागराज का असली स्वाद",
      sub: "चार उच्च-मांग वाली श्रेणियाँ — सुबह की चाय से रात की भूख तक निरंतर ग्राहक।",
      cats: [
        {
          tag: "गौरव",
          title: "प्रतिष्ठित समोसे और नमकीन",
          desc: "ODOC विजेता मिनी मसाला समोसा (हरि के समोसे), 100% देसी घी में बना — साथ में करारी, चटपटी, प्रीमियम नमकीनें जिन्हें ग्राहक थोक में ख़रीदते हैं।",
        },
        {
          tag: "आत्मा",
          title: "खस्ता समोसे और प्रयागराज स्ट्रीट फ़ूड",
          desc: "हमारे सिग्नेचर खस्ता समोसे गुप्त पारिवारिक मसालों के साथ, क्लासिक करारी कचौड़ी और पारंपरिक चटपटे चाट के थाल — प्रयागराज के तीखे, दिल को छू लेने वाले स्वाद।",
        },
        {
          tag: "भीड़ खींचने वाला",
          title: "ट्रेंडी फ़ास्ट फ़ूड",
          desc: "करारी फ्रेंच फ्राइज़, रसीले बर्गर, लोडेड सैंडविच और क्विक स्नैक्स — युवाओं और परिवारों को आकर्षित करने वाले उच्च-मार्जिन आइटम।",
        },
        {
          tag: "कैश काउंटर",
          title: "कुल्हड़ चाय और पेय",
          desc: "एक समर्पित बेवरेज काउंटर — प्रीमियम कुल्हड़ चाय, पारंपरिक स्थानीय पेय और ठंडे पेय। भारत की सबसे रोज़ की ख़रीद, आपकी स्थिर आय।",
        },
      ],
    },
    turnkey: {
      eyebrow: "बिना झंझट सेटअप",
      title: "हम बनाते हैं, आप कमाते हैं",
      sub: "एक पूर्ण, टर्नकी व्यवसाय थाल में परोसा गया। लॉन्च और संचालन की हर ज़रूरत — हमारी कॉर्पोरेट टीम संभालती है।",
      items: [
        { t: "पूरा रसोई उपकरण", d: "हेवी-ड्यूटी वाणिज्यिक उपकरण और विशेष टूल्स, मेन्यू के अनुसार पूरी तरह से तैयार।" },
        { t: "संपूर्ण प्रतिष्ठित मेन्यू", d: "ODOC विजेता समोसे, स्ट्रीट फ़ूड, फ़ास्ट फ़ूड और बेवरेज तक सीधी पहुँच।" },
        { t: "प्रीमियम कच्चा माल", d: "प्रामाणिक सामग्री और हमारे गुप्त मसाला मिश्रण की निरंतर आपूर्ति।" },
        { t: "प्रोफ़ेशनल इंटीरियर", d: "हमारी 135 वर्षीय विरासत को दर्शाती आकर्षक आउटलेट डिज़ाइन।" },
        { t: "स्टाफ़ भर्ती और प्रशिक्षण", d: "टीम भर्ती से लेकर पारंपरिक तरीकों और सेवा प्रशिक्षण तक — सब हम करते हैं।" },
        { t: "लॉन्च तक पूरी मदद", d: "स्टोर लेआउट से ग्रैंड ओपनिंग मार्केटिंग तक — पूरी ज़िम्मेदारी हमारी।" },
      ],
    },
    financials: {
      eyebrow: "आँकड़े",
      title: "फ्रेंचाइज़ी वित्तीय ब्लूप्रिंट",
      sub: "वास्तविक, टिकाऊ आय के लिए डिज़ाइन किया गया — काग़ज़ी वादे नहीं।",
      cards: [
        { label: "प्रारंभिक निवेश", value: "₹40–45L", note: "सब कुछ शामिल: डिज़ाइन, उपकरण, स्टॉक, ब्रांडिंग, लॉन्च।" },
        { label: "आवश्यक क्षेत्र", value: "150–400", unit: "वर्ग फ़ुट", note: "मुख्य सड़कों और भीड़भाड़ वाले बाज़ारों के लिए उपयुक्त।" },
        { label: "अपेक्षित मासिक आय", value: "₹10–20L", note: "स्थान, ग्राहक संख्या और स्थानीय बाज़ार पर निर्भर।" },
        { label: "निवेश पर रिटर्न", value: "2–3 वर्ष", note: "देसी घी उत्पादों और बहु-श्रेणी बिक्री पर स्वस्थ मार्जिन।" },
      ],
      royalty: "10% रॉयल्टी",
      royalty_text: "ब्रांड सहायता, सप्लाई चेन एक्सेस, मेन्यू नवाचार और राष्ट्रीय मार्केटिंग शामिल।",
    },
    premium: {
      tag: "फ्लैगशिप टियर",
      eyebrow: "हमारा प्रीमियम फ्रेंचाइज़ी प्लान",
      title: "हरि राम पुरवार का संपूर्ण संसार",
      sub: "एक फ्लैगशिप आउटलेट जिसमें हमारे ब्रांड की हर चीज़ हो — हर मसाला, हर स्नैक, हर सिग्नेचर रेसिपी। अपने शहर पर राज करने वाले गंभीर साझेदारों के लिए।",
      bullet_title: "एक छत के नीचे सब कुछ",
      bullets: [
        "संपूर्ण मसाला रिटेल रेंज",
        "पूरी नमकीन और मिठाई की श्रृंखला",
        "सभी गरम स्नैक्स, चाट और स्ट्रीट फ़ूड",
        "आधुनिक फ़ास्ट फ़ूड और बेवरेज",
        "प्रीमियम कुल्हड़ चाय काउंटर",
        "टेक-अवे, डाइन-इन और गिफ़्ट पैक",
      ],
      stats: [
        { label: "आवश्यक क्षेत्र", value: "500–1000", unit: "वर्ग फ़ुट" },
        { label: "निवेश", value: "अनुरोध पर" },
        { label: "मासिक आय", value: "₹10–20L+" },
        { label: "श्रेणी", value: "फ्लैगशिप" },
      ],
      cta_title: "प्रीमियम केवल प्रत्यक्ष आमंत्रण पर",
      cta_sub: "व्यक्तिगत प्रस्ताव, कस्टम निवेश योजना और आपके शहर की क्षमता पर विस्तृत चर्चा के लिए हमारी पार्टनरशिप टीम से सीधे बात करें।",
      cta_label_call: "पार्टनरशिप डेस्क पर कॉल करें",
    },
    form: {
      eyebrow: "अपनी यात्रा शुरू करें",
      title: "फ्रेंचाइज़ी आवेदन",
      sub: "हमें अपने बारे में बताएँ। हमारी पार्टनरशिप टीम 48 घंटों में जवाब देगी।",
      contact_title: "हमारी पार्टनरशिप टीम से बात करें",
      labels: {
        name: "पूरा नाम",
        mobile: "मोबाइल नंबर",
        email: "ईमेल पता",
        city: "लक्षित शहर",
        state: "लक्षित राज्य",
        capacity: "प्रस्तावित निवेश क्षमता",
        plan: "पसंदीदा फ्रेंचाइज़ी प्लान",
        profile: "वर्तमान व्यवसाय / अनुभव (वैकल्पिक)",
      },
      placeholders: {
        name: "जैसे आरव शर्मा",
        mobile: "10-अंकीय मोबाइल नंबर",
        email: "your@email.com",
        city: "जैसे लखनऊ",
        state: "जैसे उत्तर प्रदेश",
        profile: "अपनी पृष्ठभूमि, मौजूदा व्यवसाय या प्रासंगिक अनुभव संक्षेप में बताएँ…",
      },
      capacity_options: [
        "₹35–40 लाख",
        "₹40–45 लाख",
        "₹45–50 लाख",
      ],
      plan_options: ["स्टैंडर्ड (150–400 वर्ग फ़ुट)", "प्रीमियम (500–1000 वर्ग फ़ुट)"],
      submit: "आवेदन भेजें",
      submitting: "भेजा जा रहा है…",
      success_title: "आवेदन प्राप्त",
      success_body: "धन्यवाद — हमारी पार्टनरशिप टीम 48 घंटों में संपर्क करेगी।",
      error_title: "सबमिशन विफल",
      error_body: "कृपया पुनः प्रयास करें या सीधे कॉल करें।",
    },
    faq: {
      eyebrow: "आम सवाल",
      title: "अक्सर पूछे जाने वाले",
      items: [
        {
          q: "हरि राम पुरवार आउटलेट खोलने में कितना समय लगता है?",
          a: "साइनिंग से आमतौर पर 60 से 90 दिन — लोकेशन फ़ाइनलाइज़ेशन, इंटीरियर, उपकरण, स्टाफ़ ट्रेनिंग और सॉफ्ट लॉन्च तक।",
        },
        {
          q: "क्या साझेदार बनने के लिए पहले से F&B अनुभव चाहिए?",
          a: "नहीं। हमारा टर्नकी मॉडल पहली बार के उद्यमियों और अनुभवी ऑपरेटरों दोनों के लिए डिज़ाइन किया गया है। पूर्ण प्रशिक्षण और निरंतर सहायता दी जाती है।",
        },
        {
          q: "10% रॉयल्टी फ़ीस में क्या-क्या शामिल है?",
          a: "निरंतर ब्रांड सहायता, केंद्रीय सप्लाई चेन एक्सेस, मेन्यू नवाचार और राष्ट्रीय स्तर की मार्केटिंग अभियान।",
        },
        {
          q: "स्टैंडर्ड और प्रीमियम प्लान में क्या अंतर है?",
          a: "स्टैंडर्ड (150–400 वर्ग फ़ुट) हमारे प्रसिद्ध स्नैक्स, समोसे और चाय पर केंद्रित है। प्रीमियम (500–1000 वर्ग फ़ुट) एक फ्लैगशिप आउटलेट है — मसाले, मिठाई, नमकीन, स्ट्रीट फ़ूड, फ़ास्ट फ़ूड और बेवरेज सब कुछ।",
        },
        {
          q: "क्या एक ही शहर में कई आउटलेट खोल सकते हैं?",
          a: "हाँ। हम मल्टी-यूनिट और मास्टर फ्रेंचाइज़ी चर्चाओं का स्वागत करते हैं। आवेदन में अपनी मंशा बताएँ।",
        },
        {
          q: "क्या सभी आउटलेट पर स्वाद की निरंतरता की गारंटी है?",
          a: "बिल्कुल। हमारी केंद्रीय आपूर्ति और संरचित प्रशिक्षण — हर शहर में वही प्रसिद्ध स्वाद सुनिश्चित करते हैं।",
        },
      ],
    },
    footer: {
      tagline: "भारत की सर्वोच्च स्वाद विरासत। 1890 से।",
      call: "पार्टनरशिप डेस्क पर कॉल करें",
      address: "कृष्ण प्रणामी मंदिर के सामने, मीरापुर, प्रयागराज — 211003, उत्तर प्रदेश, भारत",
      rights: "सर्वाधिकार सुरक्षित।",
    },
  },
};

export const PHONES = ["8840397113", "9335121973"];
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_samosa-nation/artifacts/3so33v4t_WhatsApp%20Image%202026-06-07%20at%2012.08.19.jpeg";
